import { Service } from '@repo/core'
import { ConvenienceTestDraftPdfParams, ConvenienceTestDraftPdfResponse } from '@repo/user-types'
import { AxiosRequestConfig } from 'axios'

export const getConvenienceTestsDraftPdf: Service<
  ConvenienceTestDraftPdfParams,
  ConvenienceTestDraftPdfResponse,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, accept, config }) => {
  return api.get<ConvenienceTestDraftPdfResponse>('/user/me/convenience-tests/draft/pdf', {
    ...config,
    ...(accept && { headers: { Accept: accept }, responseType: 'blob' }),
  })
}
